import { render, staticRenderFns } from "./TaRightIntroScreenLanding.vue?vue&type=template&id=0f4ccc8d&scoped=true&"
import script from "./TaRightIntroScreenLanding.vue?vue&type=script&lang=js&"
export * from "./TaRightIntroScreenLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ccc8d",
  null
  
)

export default component.exports